var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBankLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 90,
    height: 90,
    rx: 6,
    fill: "#EDF8EE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.9854 48.7051C33.1285 48.8949 33.2061 49.126 33.2066 49.3637L33.251 68.902C33.253 69.8072 34.2874 70.3216 35.0102 69.7768L53.5598 55.7967C54.0443 55.4316 54.1411 54.7428 53.776 54.2583L44.0181 41.3071C43.8751 41.1173 43.7974 40.8862 43.7969 40.6485L43.7525 21.098C43.7505 20.1928 42.7161 19.6784 41.9933 20.2232L33.1563 26.8833C33.1558 26.8837 33.1563 26.8828 33.1563 26.8833L33.1534 26.8871L23.4379 34.2078C22.9534 34.573 22.8567 35.2617 23.2217 35.7463L32.9854 48.7051Z",
    fill: "#2EBB49"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.2393 48.7051C43.3824 48.8949 43.46 49.126 43.4605 49.3637L43.5049 68.902C43.5069 69.8072 44.5413 70.3216 45.2641 69.7768L63.8137 55.7967C64.2982 55.4316 64.395 54.7428 64.0299 54.2583L54.272 41.3072C54.129 41.1173 54.0514 40.8862 54.0508 40.6485L54.0064 21.098C54.0044 20.1928 52.97 19.6784 52.2472 20.2232L43.4102 26.8833C43.4097 26.8837 43.4102 26.8828 43.4102 26.8833L43.4073 26.8871L33.6918 34.2078C33.2073 34.573 33.1106 35.2617 33.4756 35.7463L43.2393 48.7051Z",
    fill: "#7F43FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.4445 49.3415C43.4439 49.1039 43.3664 48.8728 43.2234 48.6831L33.4595 35.724C33.0945 35.2395 33.1913 34.5509 33.6757 34.1858L43.3896 26.8648C43.3901 26.8644 43.3909 26.8645 43.3913 26.865C43.392 26.8659 43.3935 26.8654 43.3934 26.8643L43.3934 26.8626C43.3934 26.8621 43.3937 26.8616 43.3941 26.8612L43.749 26.5938L43.7801 40.2605C43.7811 40.7357 43.9363 41.1978 44.2223 41.5774L53.0992 53.3592C53.8292 54.3281 53.6357 55.7054 52.6668 56.4356L43.829 63.0963L43.829 63.0963L43.8289 63.0963L43.4763 63.362L43.4445 49.3415Z",
    fill: "#165724"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBankLogo);
export default __webpack_public_path__ + "static/media/bank_logo.c467fd1b2b5ec2c46565cc98d3e5777d.svg";
export { ForwardRef as ReactComponent };